import Model from "../Model";
import Loading from "../Loading";
import tw from "tailwind-styled-components";
import { IoIosWarning } from "react-icons/io";

const TenantDeleteModal = ({
    setTenantDeleteModal,
  deleteMutate,
  isdeleteTenantLoading,
  selectedData

}) => {
 // console.log(selectedData)
  const deleteSubmit = () => {
    deleteMutate({
      //tenantId: selectedData.tenantId, //dec 30 change with occupancyId changed by anurag
      occupancyId: selectedData.occupancyId,
    })
  }
  return (
    <Model
      width={`xl:w-1/3 lg:w-2/5 md:w-1/2 sm:w-2/3 w-11/12 max-w-lg`}
      height={`h-auto max-h-md`}
      setOpenModel={setTenantDeleteModal}
    >
      <div className="text-center w-full p-1">
        {/* Title Section */}
        <Title>Confirm user removal</Title>
        <Label>
          Are you sure you want to delete this tenant from
          <br className="hidden sm:block" /> the kipinn platform?
        </Label>

        {/* Warning Section */}
        <WarningSection>
          <div className="flex items-center gap-2">
            <IoIosWarning className="text-amber-500 text-xl" />
            <WarningTitle>Warning</WarningTitle>
          </div>
          <WarningText>
            By deleting this tenant, their associated data will also be
            permanently deleted.
          </WarningText>
        </WarningSection>

        {/* Buttons Section */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 justify-center my-4 sm:my-6">
          <Button
            className="bg-slate-500 hover:bg-slate-600"
            onClick={() => setTenantDeleteModal(false)}
          >
            Close
          </Button>
          <Button
            className="bg-rose-500 hover:bg-rose-600"
            onClick={deleteSubmit}
          >
            {isdeleteTenantLoading ? (
              <Loading
                height={16}
                width={16}
                noPadding={true}
                color={"#ffffff"}
              />
            ) : (
              "Delete"
            )}
          </Button>
        </div>
      </div>
    </Model>
  );
};

const Label = tw.label`text-sm sm:text-md text-gray-500 font-normal`;
const Title = tw.h2`text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 font-medium my-2 text-center`;
const WarningSection = tw.div`bg-gray-100 rounded-lg p-3 sm:p-4 my-4`;
const WarningTitle = tw.span`text-left text-amber-500 font-semibold`;
const WarningText = tw.p`text-left text-xs sm:text-sm text-gray-600 my-1`;

const Button = tw.button`text-xs sm:text-sm text-white px-6 sm:px-8 py-2 sm:py-3 rounded-lg transition-all hover:scale-105`;

export default TenantDeleteModal;